import { axiosHelper } from 'Services/AxiosHelper';
import { OnLoginModel } from 'Models';
import { onLoginLogListReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnLoginLogList';

const onLoginLogList = async (params: onLoginLogListReqBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onLoginLogList;
